import React from 'react';
import { Link } from 'react-router-dom';

function Programs() {
  const programs = [
    {
      id: 'international-mobility',
      category: 'International Mobility Programs',
      desc: 'EFIS offers a wide range of international mobility opportunities for young people and citizens, including volunteering, non-formal education, and structured exchange programs.',
      items: [
        'European mobility and volunteering (ESC)',
        'Erasmus+ international exchanges & non-formal learning',
        'UN-linked youth and community initiatives',
        'Cross-cultural learning & dialogue networks'
      ]
    },
    {
      id: 'global-citizenship',
      category: 'Promotion of Global Citizenship',
      desc: 'Organizing initiatives that raise awareness of solidarity, human rights, and shared global responsibility, encouraging participants to act as engaged global citizens.',
      items: [
        'Human rights campaigns & public debates',
        'Tolerance & anti-discrimination workshops',
        'Active civic engagement advocacy',
        'Solidarity campaigns locally and globally'
      ]
    },
    {
      id: 'cooperation-development',
      category: 'International Cooperation & Development',
      desc: 'Developing projects aimed at supporting sustainable development, social inclusion, and reducing social and economic disparities worldwide.',
      items: [
        'Global South and North educational partnerships',
        'Support for local entrepreneurship & microfinance',
        'Clean water and resource distribution support',
        'Inclusion projects for disadvantaged backgrounds'
      ]
    },
    {
      id: 'youth-empowerment',
      category: 'Youth Empowerment & Capacity Building',
      desc: 'Providing workshops, training sessions, and learning opportunities to strengthen leadership, intercultural dialogue, civic engagement, and teamwork.',
      items: [
        'Youth leadership summits & networking events',
        'Capacity building workshops for youth workers',
        'Non-formal education methods & coaching',
        'Skills development (languages, digital literacy, planning)'
      ]
    }
  ];

  return (
    <main>
      {/* Hero Start */}
      <div className="slider-area2">
        <div className="slider-height2 d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="hero-cap hero-cap2 pt-20 text-center">
                  <h2>Our Programs</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Area */}
      <div className="service-area section-padding30">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-10">
              <div className="section-tittle text-center mb-80">
                <span>Core Activities</span>
                <h2>What We Offer</h2>
                <p>Click on any program to see publications, volunteer reports, and projects related to that category.</p>
              </div>
            </div>
          </div>
          <div className="row">
            {programs.map((program, index) => (
              <div key={index} className="col-lg-6 col-md-6 mb-40">
                <div className="single-cat h-100 text-left p-40 d-flex flex-column justify-content-between" style={{border: '1px solid #e2e8f0', borderRadius: '12px', background: '#fff', boxShadow: '0 5px 15px rgba(0,0,0,0.02)', transition: 'all 0.3s'}}>
                  <div>
                    <div className="cat-cap">
                      <h4 style={{fontWeight: '700', marginBottom: '15px'}}>{program.category}</h4>
                      <p style={{fontSize: '14.5px', color: '#4b5563', lineHeight: '1.6', marginBottom: '20px'}}>{program.desc}</p>
                      
                      <h5 style={{fontWeight: '600', marginBottom: '10px', fontSize: '15px', color: 'var(--primary-blue)'}}>Key Focus Areas:</h5>
                      <ul style={{textAlign: 'left', listStyle: 'none', paddingLeft: '0'}}>
                        {program.items.map((item, idx) => (
                          <li key={idx} style={{marginBottom: '10px', fontSize: '14px', color: '#4b5563', display: 'flex', alignItems: 'center'}}>
                            <span style={{color: 'var(--accent-red)', marginRight: '10px', fontWeight: 'bold'}}>✓</span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div style={{marginTop: '30px'}}>
                    <Link to={`/programs/${program.id}`} className="btn w-100" style={{textAlign: 'center'}}>View Projects & Publications</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="wantToWork-area">
        <div className="container">
          <div className="wants-wrapper w-padding2 section-bg" style={{ 
            backgroundImage: `url('/assets/img/gallery/section_bg02.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}>
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-5 col-lg-9 col-md-8">
                <div className="wantToWork-caption wantToWork-caption2">
                  <h2>Ready to Make a Difference?</h2>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-4">
                <Link to="/contact" className="btn white-btn f-right sm-left">Get Involved</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Programs;